import React from 'react';
import { useLanguage } from '../context/LanguageContext';
import { MapPin, Mail } from 'lucide-react';

const Footer = () => {
  const { t } = useLanguage();

  return (
    <footer className="bg-gray-900 text-white py-16">
      <div className="container mx-auto px-4 lg:px-8">
        <div className="grid md:grid-cols-2 lg:grid-cols-4 gap-12 mb-12">
          {/* Brand */}
          <div>
            <h3 className="text-2xl font-bold bg-gradient-to-r from-blue-400 to-teal-400 bg-clip-text text-transparent mb-4">
              0g Baltics
            </h3>
            <p className="text-gray-400 mb-4">
              IoT solutions for municipalities, industries, and public institutions across the Baltics.
            </p>
            <div className="flex items-center space-x-2 text-gray-400">
              <Mail className="w-5 h-5" />
              <a href="mailto:info@0gbaltics.com" className="hover:text-teal-400 transition-colors">
                info@0gbaltics.com
              </a>
            </div>
          </div>

          {/* Solutions */}
          <div>
            <h4 className="text-lg font-semibold mb-4">{t.footer.solutions}</h4>
            <ul className="space-y-2 text-gray-400">
              <li><a href="#solutions" className="hover:text-teal-400 transition-colors">Smart Metering</a></li>
              <li><a href="#solutions" className="hover:text-teal-400 transition-colors">Energy Monitoring</a></li>
              <li><a href="#solutions" className="hover:text-teal-400 transition-colors">Asset Tracking</a></li>
              <li><a href="#solutions" className="hover:text-teal-400 transition-colors">Indoor Air Quality</a></li>
              <li><a href="#solutions" className="hover:text-teal-400 transition-colors">Smart Libraries</a></li>
              <li><a href="#solutions" className="hover:text-teal-400 transition-colors">Parking AI</a></li>
            </ul>
          </div>

          {/* Company */}
          <div>
            <h4 className="text-lg font-semibold mb-4">{t.footer.company}</h4>
            <ul className="space-y-2 text-gray-400">
              <li><a href="#industries" className="hover:text-teal-400 transition-colors">{t.nav.industries}</a></li>
              <li><a href="#technologies" className="hover:text-teal-400 transition-colors">{t.nav.technologies}</a></li>
              <li><a href="#cases" className="hover:text-teal-400 transition-colors">{t.nav.references}</a></li>
              <li><a href="#blog" className="hover:text-teal-400 transition-colors">{t.nav.blog}</a></li>
              <li><a href="#contact" className="hover:text-teal-400 transition-colors">{t.nav.contact}</a></li>
            </ul>
          </div>

          {/* Legal & Offices */}
          <div>
            <h4 className="text-lg font-semibold mb-4">{t.footer.offices}</h4>
            <div className="space-y-4 text-gray-400 text-sm">
              {/* Lithuania */}
              <div>
                <div className="flex items-start space-x-2 mb-1">
                  <MapPin className="w-4 h-4 mt-1 flex-shrink-0 text-teal-400" />
                  <div>
                    <p className="font-semibold text-white">{t.footer.lithuania}</p>
                    <p>0g Baltics UAB</p>
                    <p>A. Goštauto g. 8-358</p>
                    <p>LT-01108 Vilnius</p>
                  </div>
                </div>
              </div>

              {/* Latvia */}
              <div>
                <div className="flex items-start space-x-2 mb-1">
                  <MapPin className="w-4 h-4 mt-1 flex-shrink-0 text-teal-400" />
                  <div>
                    <p className="font-semibold text-white">{t.footer.latvia}</p>
                    <p>0g Baltics SIA</p>
                    <p>Elizabetes iela 31-8</p>
                    <p>LV-1010 Riga</p>
                  </div>
                </div>
              </div>

              {/* Estonia */}
              <div>
                <div className="flex items-start space-x-2">
                  <MapPin className="w-4 h-4 mt-1 flex-shrink-0 text-teal-400" />
                  <div>
                    <p className="font-semibold text-white">{t.footer.estonia}</p>
                    <p>E2 Technologies OÜ</p>
                    <p>Lõõtsa tn 5</p>
                    <p>11415 Tallinn</p>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>

        {/* Bottom Bar */}
        <div className="border-t border-gray-800 pt-8 text-center text-gray-400">
          <p>{t.footer.rights}</p>
        </div>
      </div>
    </footer>
  );
};

export default Footer;